import { render, staticRenderFns } from "./DownloadDistributionOrderBilling.vue?vue&type=template&id=99564d0a&scoped=true&"
import script from "./DownloadDistributionOrderBilling.vue?vue&type=script&lang=js&"
export * from "./DownloadDistributionOrderBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99564d0a",
  null
  
)

export default component.exports